import React from 'react';
import styled from 'styled-components';
import { mq } from '../../../../../../common/src/utils/styledComponentsUtils';

// Components
import CheckMark from '../../../../../../common/src/components/CheckMark';

interface Props {
  title: string;
  value: boolean;
  onSelected: () => void;
}

const SingleMultiSelectTextInput: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  value,
  onSelected,
  ...otherProps
}) => {
  return (
    <Wrapper
      data-test-id="ProdFac_SingleMultiSelectInput"
      onClick={onSelected}
      {...otherProps}
    >
      <TextWrapper checked={value}>
        <Title>{title}</Title>
        {value && <StyledIconCheckmark />}
      </TextWrapper>
    </Wrapper>
  );
};

const StyledIconCheckmark = styled(CheckMark)`
  position: absolute;
  top: -1.6rem;
  right: -1.6rem;
`;

const Title = styled.h5`
  font-size: 2.8rem;
  text-align: center;
`;

const TextWrapper = styled.div<{ checked?: boolean }>`
  position: relative;
  box-shadow: 0 0 1px rgba(40, 41, 61, 0.04), 0 2px 4px rgba(96, 97, 112, 0.16);
  border-radius: 10px;
  border: ${({ checked, theme }) =>
    checked ? `2px solid ${theme.primary[500]}` : 'none'};
  width: 10rem;
  height: 10rem;
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;
  transition: background-color 0.2s;
  &:hover {
    background: #fafafa;
  }

  ${mq.tablet} {
    padding: ${({ checked }) => (checked ? 'calc(4rem - 2px)' : '4rem')};
  }
`;

const Wrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export default SingleMultiSelectTextInput;
